export const getTranslatedContentField = (field: string, tc: {[lang: string]: any}, lang: string): string => {
    const langs = Object.keys(tc || {}).sort();
    if(!tc || langs.length === 0) return "";
    return tc[lang] ? tc[lang][field] : tc[langs[0]][field];
}

export const getTranslatedBody = (tc, lang: string) => getTranslatedContentField("body", tc, lang)
export const getTranslatedTitle = (tc, lang: string) => getTranslatedContentField("title", tc, lang)
export const getTranslatedComplianceText = (tc, lang: string) => getTranslatedContentField("complianceText", tc, lang)
export const getTranslatedDescription = (tc, lang: string) => getTranslatedContentField("description", tc, lang)
export const getTranslatedExcerpt = (tc, lang: string) => getTranslatedContentField("excerpt", tc, lang)